export const legend = [
  {
    id: 1,
    descricao: "PONTA DE AGULHA TABLETE",
    codigo: "400g",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/ponta-de-agulha-tablet-400g/produto-01.webp",
      "/images/ponta-de-agulha-tablet-400g/produto-02.webp",
      "/images/ponta-de-agulha-tablet-400g/produto-03.webp",
      "/images/ponta-de-agulha-tablet-400g/produto-04.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 2,
    descricao: "PONTA DE AGULHA RETANGULAR",
    codigo: "5kg",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/ponta-de-agulha-retangular-5kg/produto-01.webp",
      "/images/ponta-de-agulha-retangular-5kg/produto-02.webp",
      "/images/ponta-de-agulha-retangular-5kg/produto-03.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 3,
    descricao: "PONTA DE AGULHA CUBOS",
    codigo: "500g",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/ponta-de-agulha-cubos-500g/produto-01.webp",
      "/images/ponta-de-agulha-cubos-500g/produto-02.webp",
      "/images/ponta-de-agulha-cubos-500g/produto-03.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 4,
    descricao: "PONTA DE AGULHA",
    codigo: "5kg",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/ponta-de-agulha-5kg/produto-01.webp",
      "/images/ponta-de-agulha-5kg/produto-02.webp",
      "/images/ponta-de-agulha-5kg/produto-03.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 5,
    descricao: "DIANTEIRO TABLETE",
    codigo: "500g",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/dianteiro-tablet-500g/produto-01.webp",
      "/images/dianteiro-tablet-500g/produto-02.webp",
      "/images/dianteiro-tablet-500g/produto-03.webp",
      "/images/dianteiro-tablet-500g/produto-04.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 6,
    descricao: "DIANTEIRO RETANGULAR",
    codigo: "5kg",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/dianteiro-retangular-5kg/produto-01.webp",
      "/images/dianteiro-retangular-5kg/produto-02.webp",
      "/images/dianteiro-retangular-5kg/produto-03.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 7,
    descricao: "DIANTEIRO CUBOS",
    codigo: "500g",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/dianteiro-cubos-500g/produto-01.webp",
      "/images/dianteiro-cubos-500g/produto-02.webp",
      "/images/dianteiro-cubos-500g/produto-03.webp",
      "/images/dianteiro-cubos-500g/produto-04.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 8,
    descricao: "DIANTEIRO",
    codigo: "5kg",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/dianteiro-5kg/produto-01.webp",
      "/images/dianteiro-5kg/produto-02.webp",
      "/images/dianteiro-5kg/produto-03.webp",
      "/images/dianteiro-5kg/produto-04.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 9,
    descricao: "SABOR NORDESTINO PONTA DE AGULHA TABLETE",
    codigo: "500g",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/sabor-nordestino-ponta-de-agulha-tablet-500g/produto-01.webp",
      "/images/sabor-nordestino-ponta-de-agulha-tablet-500g/produto-02.webp",
      "/images/sabor-nordestino-ponta-de-agulha-tablet-500g/produto-03.webp",
      "/images/sabor-nordestino-ponta-de-agulha-tablet-500g/produto-04.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
  {
    id: 10,
    descricao: "SABOR NORDESTINO PONTA DE AGULHA",
    codigo: "5kg",
    embalagemUnidade: "10kg",
    embalagemMaster: "10kg",
    imagem: [
      "/images/sabor-nordestino-ponta-de-agulha-5kg/produto-01.webp",
      "/images/sabor-nordestino-ponta-de-agulha-5kg/produto-02.webp",
      "/images/sabor-nordestino-ponta-de-agulha-5kg/produto-03.webp",
    ],
    nutricionais: [
      { title: "Valor energético(kcal)", peso: "196", porcentagem: "3" },
      { title: "Carboidratos(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares totais(g)", peso: "0", porcentagem: "0" },
      { title: "Açúcares adicionados(g)", peso: "0", porcentagem: "0" },
      { title: "Proteínas(g)", peso: "31", porcentagem: "19" },
      { title: "Gorduras totais(g)", peso: "8,1", porcentagem: "4" },
      { title: "Gorduras saturadas(g)", peso: "3,9", porcentagem: "6" },
      { title: "Gorduras trans(g)", peso: "0", porcentagem: "0" },
      { title: "Fibra alimentares(g)", peso: "0", porcentagem: "0" },
      { title: "Sódio(mg)", peso: "2532", porcentagem: "38" },
    ],
  },
];
